export default __webpack_public_path__ + "static/media/rocket_anim_61.906f5f1f.png";